import { useEffect, useState } from "react";
import styles from "./MeusProdutos.module.scss";
import PageContainer from "shared/components/pagecontainer/PageContainer";
import { IProduto } from "shared/interfaces/IProduto";
import ProdutoItem from "shared/components/produtoitem/ProdutoItem";
import { useNavigate } from "react-router-dom";
import {  PlusSquare,  SquareChartGantt,} from "lucide-react";
import { meusProdutos } from "shared/services/api/produto.api";


export const MeusProdutos:React.FC=() => {

  const [produtos,setProdutos]= useState<IProduto[]>([]);
  const [loading,setLoading]= useState(true);

  const navigate=useNavigate();

  function handleDeleteProduto( id:string ){
    setProdutos((prev) =>  prev.filter((produto) => produto.id !== id));
  }
  
  useEffect(() => { loadProdutos(); }, []);
  
  async function loadProdutos() {

  try {
    const produtos = await meusProdutos();

    setProdutos(produtos);

  } catch (error) {

    console.error( "Erro ao carregar produtos:", error );

  } finally { setLoading(false); }
}
  return (
    <PageContainer title="Meus Produtos" showDesktopSearch={false} icon={<SquareChartGantt size={18} />}
    contentClassName={styles.whiteContent} showLogo logo={<img src="/imagens/menuLogo.png" alt="Move"/>} >

      <div className={styles.page}>

        <div className={styles.containerAdd} onClick={() => navigate("/cadastroproduto")}>
          <p>Adicionar Produto</p>
          <PlusSquare  className={styles.iconAdd}/>
        </div>

        {loading && (<p className={styles.loading}>Carregando produtos...</p>)}
        {!loading && produtos.length > 0 && (
          <div className={styles.list}>
            {produtos.map((produto) => (
              <ProdutoItem key={produto.id} produto={produto} onDelete={handleDeleteProduto}/>
            ))}
          </div>
        )}

        {!loading &&  produtos.length === 0 && (<p className={styles.empty}>
            Nenhum produto cadastrado.
          </p>
        )}
     </div>
    </PageContainer>
  );
}